<article class="tw-flex tw-space-x-4">
  <button
      mhFilterTrigger
      [filterOpen]="isOpen"
      (click)="isOpen = !isOpen"
      cdkOverlayOrigin #trigger="cdkOverlayOrigin"
      >
      <i class="far fa-filter tw-text-neutral-500" [class.!tw-text-main-blue]="areFiltersApplied"></i>
      <span class="tw-hidden tw-whitespace-nowrap tw-text-neutral-500 md:tw-inline">
        {{'core-lib.selectors.desk.filter_by' | translate}}
      </span>
      <i class="fal fa-angle-down tw-hidden tw-text-base tw-ml-1 tw-text-neutral-400 md:tw-inline"></i>
  </button>

  <button mhFilterTrigger [filterIconOnly]="true" (click)="clearFilters()" *ngIf="areFiltersApplied">
    <span class="tw-relative tw-inline-flex">
      <i class="far fa-filter tw-text-neutral-500"></i>
      <i class="fas fa-times-circle tw-absolute -tw-right-1.5 -tw-top-1 tw-text-[9px] tw-text-red-500"></i>
    </span>
  </button>
</article>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPanelClass]="['!tw-inset-x-0', 'tw-mx-auto', 'tw-absolute', 'overlay-centered']"
>
<div class="tw-bg-white tw-shadow-1 tw-rounded tw-flex tw-flex-col tw-mt-3" id="overlayFiltersOnlineReviews">

  <div class="tw-flex tw-flex-col xl:tw-flex-row xl:tw-border-b-2 xl:tw-border-border-light-gray">
      <div class="tw-min-w-[240px] xl:tw-min-h-[200px] tw-max-w-[240px] tw-max-h-[200px] xl:tw-border-r-2 xl:tw-border-border-light-gray tw-pb-1 tw-pt-3 tw-px-3 xl:tw-p-3 tw-overflow-y-scroll">
        <div class="tw-flex" (click)="toggleMobileFilter('ota')">
          <span class="tw-mr-2 tw-font-medium tw-text-main-text">OTA</span>
          <i [@rotate]="otaFilterStatus ? '-180' : '0'" class="far fa-angle-down tw-text-main tw-self-center xl:tw-hidden"></i>
        </div>
        <div  [@collapsedHeightState]="otaFilterStatus ? 'expand' : 'collapse'">
          <mh-core-lib-checkbox-input
              [options]="otas"
              [displayOptionsFn]="displayOTAOptions"
              (optionClicked)="setReviewFilterState($event)">
          </mh-core-lib-checkbox-input>

        </div>
      </div>

      <div class="tw-min-w-[240px] xl:tw-min-h-[200px] tw-max-w-[240px] tw-max-h-[200px] xl:tw-border-r-2 xl:tw-border-border-light-gray tw-py-1 tw-px-3 xl:tw-p-3 tw-overflow-y-scroll">
        <div class="tw-flex" (click)="toggleMobileFilter('answer')">
          <span class="tw-mr-2 tw-font-medium tw-text-main-text">{{'commons.answer' | translate}}</span>
          <i [@rotate]="answerFilterStatus ? '-180' : '0'" class="far fa-angle-down tw-text-main tw-self-center xl:tw-hidden"></i>
        </div>
        <div  [@collapsedHeightState]="answerFilterStatus ? 'expand' : 'collapse'">
          <mh-core-lib-checkbox-input
              [options]="answerOptions"
              [displayOptionsFn]="displayAnswerOptions"
              (optionClicked)="setReviewFilterState($event)">
          </mh-core-lib-checkbox-input>
        </div>
      </div>
      <div class="tw-min-w-[240px] xl:tw-min-h-[200px] tw-max-w-[240px] tw-max-h-[200px] xl:tw-border-r-2 xl:tw-border-border-light-gray tw-py-1 tw-px-3 xl:tw-p-3">
        <div class="tw-flex" (click)="toggleMobileFilter('nps')">
          <span class="tw-mr-2 tw-font-medium tw-text-main-text">NPS</span>
          <i [@rotate]="npsFilterStatus ? '-180' : '0'" class="far fa-angle-down tw-text-main tw-self-center xl:tw-hidden"></i>
        </div>
        <div  [@collapsedHeightState]="npsFilterStatus ? 'expand' : 'collapse'">
          <mh-core-lib-checkbox-input
              [options]="npsOptions"
              [displayOptionsFn]="displayNpsOptions"
              (optionClicked)="setReviewFilterState($event)">
          </mh-core-lib-checkbox-input>
        </div>
      </div>
      <div class=" tw-min-w-[240px] xl:tw-min-h-[180px] tw-max-w-[240px] tw-max-h-[180px] xl:tw-border-r-2 xl:tw-border-border-light-gray tw-p-1 tw-px-3 xl:tw-p-3">
        <div class="tw-flex" (click)="toggleMobileFilter('cases')">
          <span class="tw-mr-2 tw-font-medium tw-text-main-text">{{'core-lib.selectors.guest.filters_title.cases' | translate}}</span>
          <i [@rotate]="casesFilterStatus ? '-180' : '0'" class="far fa-angle-down tw-text-main tw-self-center xl:tw-hidden"></i>
        </div>
        <div [@collapsedHeightState]="casesFilterStatus ? 'expand' : 'collapse'">
          <mh-core-lib-checkbox-input
              [options]="deskOptions"
              [translatePrefix]="'followup.survey.filter.'"
              (optionClicked)="setReviewFilterState($event)">
          </mh-core-lib-checkbox-input>
        </div>
      </div>
  </div>
  <div class="tw-flex tw-flex-col xl:tw-flex-row xl:tw-border-b-2 xl:tw-border-border-light-gray">
      <div class="tw-min-w-[240px] xl:tw-min-h-[200px] tw-max-w-[240px] tw-max-h-[200px] xl:tw-border-r-2 xl:tw-border-border-light-gray tw-py-1 tw-px-3 xl:tw-p-3">
        <div class="tw-flex" (click)="toggleMobileFilter('qualification')">
          <span class="tw-mr-2 tw-font-medium tw-text-main-text">{{'commons.qualify' | translate}}</span>
          <i [@rotate]="qualificationFilterStatus ? '-180' : '0'" class="far fa-angle-down tw-text-main tw-self-center xl:tw-hidden"></i>
        </div>
        <div  [@collapsedHeightState]="qualificationFilterStatus ? 'expand' : 'collapse'">
          <mh-core-lib-checkbox-input
              [options]="qualificationOptions"
              [displayOptionsFn]="displayQualificationOptions"
              [displayHtml]="true"
              (optionClicked)="setReviewFilterState($event)">
          </mh-core-lib-checkbox-input>
        </div>
      </div>
      <div class="tw-min-w-[240px] xl:tw-min-h-[200px] tw-max-w-[240px] xl:tw-border-r-2 xl:tw-border-border-light-gray tw-py-1 tw-px-3 xl:tw-p-3 tw-overflow-visible">
        <div class="tw-flex" (click)="toggleMobileFilter('reason')">
          <span class="tw-mr-2 tw-font-medium tw-text-main-text">{{'commons.type_traveler.title' | translate}}</span>
          <i [@rotate]="reasonFilterStatus ? '-180' : '0'" class="far fa-angle-down tw-text-main tw-self-center xl:tw-hidden"></i>
        </div>
        <div  [@collapsedHeightState]="reasonFilterStatus ? 'expand' : 'collapse'">
          <mh-core-lib-tag-input
              [options]="reasonOptions"
              [displayChipsFn]="displayChipsFn"
              [displayChipsListFn]="displayChipsFn"
              [allSelected]="false"
              [checkedAllOption]="false"
              [showAutocompleteInput]="true"
              [inputTagFilter]="inputTagFilter"
              [displayCheckInput]="false"
              [boxOpen]="false"
              [placeholder]="('commons.work' | translate | titlecase)+', '+('commons.couples' | translate | titlecase)+'...'"
              (optionClicked)="setReviewFilterState($event)"
              ></mh-core-lib-tag-input>
        </div>
      </div>
      <div class="tw-min-w-[240px] xl:tw-min-h-[200px] tw-max-w-[240px] tw-max-h-[200px] xl:tw-border-r-2 xl:tw-border-border-light-gray tw-py-1 tw-px-3 xl:tw-p-3 tw-overflow-y-scroll">
        <div class="tw-flex" (click)="toggleMobileFilter('language')">
          <span class="tw-mr-2 tw-font-medium tw-text-main-text">{{'languages.iso.language' | translate}}</span>
          <i [@rotate]="languageFilterStatus ? '-180' : '0'" class="far fa-angle-down tw-text-main tw-self-center xl:tw-hidden"></i>
        </div>
        <div  [@collapsedHeightState]="languageFilterStatus ? 'expand' : 'collapse'">
      <mh-core-lib-checkbox-input
          [options]="languageOptions"
          [displayOptionsFn]="displayLanguageFn"
          (optionClicked)="setReviewFilterState($event)">
      </mh-core-lib-checkbox-input>
        </div>
      </div>
  </div>
</div>
</ng-template>
